/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SignupStep } from './';
import {
    SignupStepFromJSON,
    SignupStepFromJSONTyped,
    SignupStepToJSON,
} from './';

/**
 * 
 * @export
 * @interface StepPublicEmailWarning
 */
export interface StepPublicEmailWarning extends SignupStep {
    /**
     * The email address provided by the user
     * @type {string}
     * @memberof StepPublicEmailWarning
     */
    email: string;
}

/**
 * Check if a given object implements the StepPublicEmailWarning interface.
 */
export function instanceOfStepPublicEmailWarning(value: object): value is StepPublicEmailWarning {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function StepPublicEmailWarningFromJSON(json: any): StepPublicEmailWarning {
    return StepPublicEmailWarningFromJSONTyped(json, false);
}

export function StepPublicEmailWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepPublicEmailWarning {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepFromJSONTyped(json, ignoreDiscriminator),
        'email': json['email'],
    };
}

export function StepPublicEmailWarningToJSON(value?: StepPublicEmailWarning | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepToJSON(value, true),
        'email': value['email'],
    };
}

